<div class="flow_header">
  <label class="flow_label">Save To Existing Bot</label>
  <div class="flow_save_new_container">
    <div class="flow_save_new_img_btn" (click)="closeModal()"></div>
  </div>
</div>
@if (!loadingData) {
  <div  [formGroup]="existingForm" class="form_content">
    <div class="flow_save_new">
      <div class="flow_save_new_description">Select An Existing Bot </div>
      @if (existingForm.controls['existingBotList'].invalid && existingForm.controls['existingBotList'].touched) {
        <span class="flow_save_new_error"
          >
          An existing bot is required
        </span>
      }
      <div class="flow_save_new_inputContainer">
        <div class="flow_save_new_dropdown">
          <mat-select
            #ExistingBot
            class = "existingBotDropdown"
            formControlName = "existingBotList"
            [placeholder]="'Select a bot'"
            (click) = "selectNewBot()">
            @for (bot of botList; track bot) {
              <mat-option value='{{bot}}'> {{bot}}</mat-option>
            }
          </mat-select>
        </div>
      </div>
      <br/>
      <div class="flow_save_new_description">Template Name</div>
      @if (existingForm.controls['templateName'].invalid && existingForm.controls['templateName'].touched && containsWrongValue) {
        <span class="flow_save_new_error "
          >
          Template name is required
        </span>
      }
      @if (containsWrongValue) {
        <span class="flow_save_new_error "
          >
          Template name is not correct
        </span>
      }
      <div class="flow_save_new_inputContainer">
        <input
          formControlName="templateName" class="flow_save_new_input" placeholder="Enter a template name"
          (ngModelChange)="saveTemplateNameChange($event)"
          />
        </div>
      </div>
    </div>
  } @else {
    <div class="loading">
      <loading-icon style="align-self: center"></loading-icon>
    </div>
  }


    <div class="flow_save_new_buttonsContainer
                   {{(existingForm.controls['templateName'].invalid && existingForm.controls['templateName'].touched && containsWrongValue)?'templateError':''}}
                   {{containsWrongValue?'templateError':''}}
                   {{(existingForm.controls['existingBotList'].invalid && existingForm.controls['existingBotList'].touched)?'botListError':''}}" >
    <button class="flow_save_new_cancelBtn flow_save_new_button" (click)="closeModal()">
      Cancel
    </button>
    <button class="{{changesMade?'flow_save_new_saveBtn':'flow_save_new_saveBtnDisabled'}} flow_save_new_button" (click)="saveExistingModal()">
      Save
    </button>
  </div>
